export default __webpack_public_path__ + "node_modules/leaflet/dist/images/marker-shadow.a0c6cc1401c107b501efee6477816891.png";